export enum RoutePaths {
  all = '*',
  root = '/',
  auth = '/authorization',
  events = '/events',
  reports = '/reports',
  users = '/users',
  mailings = '/mailings',
  roles = '/roles',
  groups = '/groups',
  transport = '/transport',
  alcolocks = '/alcolocks',
  links = '/links',
  servicemode = '/servicemode',
  servicemodehistory = '/servicemodehistory',
  changePassword = '/changePassword',
  confirmPassword = '/confirmPassword',
  forgetPassword = '/forgetPassword',
  resetPassword = '/resetPassword',
  templates = '/templates',
  settings = '/settings',
  mpoConfig = '/mpo-config',
  map = '/map',
  /** Отдельное окно чата оператора (window.open); см. OperatorChatPopupPage */
  operatorChatPopup = '/operator-chat-popup',
}
